/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import { Text } from '../texts';
import Waves from '../waves';
import { RECTANGLE_BORDER_COLORS } from './constants';
import {
  RectangleButtonStyle,
  RectangleButtonStyleWithIcon,
} from './rectangle';

interface RectangleButtonProps {
  Icon?: React.ComponentType;
  mood?: string;
  ghost?: boolean;
  size?: string;
  width?: number;
  height?: number;
  text?: string;
  textColor?: string;
  textHoverColor?: string;
  rightIcon?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  backgroundColor?: string;
  borderColor?: string;
  iconHeight?: number;
  fontSize?: number;
  fontFamily?: string;
  borderRadius?: number;
  type?: string;
  className?: string;
  id?: string;
  borderWidth?: number;
}

const RectangleButtonComponent: React.FC<RectangleButtonProps> = (props) => {
  const {
    Icon,
    mood,
    ghost,
    size,
    width,
    height,
    text,
    textColor,
    textHoverColor,
    rightIcon,
    onClick,
    backgroundColor,
    borderColor,
    iconHeight,
    fontSize,
    fontFamily,
    borderRadius,
    type,
    className,
    id,
    borderWidth,
  } = props;
  const colorText = textColor
    ? textColor
    : !mood
      ? 'gray'
      : ghost
        ? RECTANGLE_BORDER_COLORS[mood]
        : mood === 'disabled'
          ? 'pale'
          : 'white';
  const buttonOnClick = onClick
    ? (e) => {
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      mood !== 'disabled' && onClick(e);
    }
    : () => ({});
  if (Icon) {
    return (
      <RectangleButtonStyleWithIcon
        {...{
          rightIcon,
          mood,
          ghost,
          size,
          colorText,
          width,
          height,
          backgroundColor,
          borderColor,
          iconHeight,
          borderRadius,
          textHoverColor,
          borderWidth,
        }}
        onClick={buttonOnClick}
        type={type}
        id={id}
      >
        {!rightIcon && <Icon />}
        <Waves color={mood ? 'white' : 'turquoise'} />
        <Text color={colorText} fontFamily={fontFamily} fontSize={fontSize}>
          {text}
        </Text>
        {rightIcon && <Icon />}
      </RectangleButtonStyleWithIcon>
    );
  } else
    return (
      <RectangleButtonStyle
        {...{
          mood,
          ghost,
          size,
          width,
          height,
          backgroundColor,
          borderColor,
          borderRadius,
          type,
          textHoverColor,
          id,
          borderWidth,
        }}
        onClick={buttonOnClick}
        type={type}
        data-inner-text={text}
        id={id}
      >
        <Waves color={mood ? 'white' : 'turquoise'} className={className} />
        <Text color={colorText} fontFamily={fontFamily} fontSize={fontSize}>
          {text}
        </Text>
      </RectangleButtonStyle>
    );
};

export const RectangleButton = React.memo(RectangleButtonComponent);

